export default "__VITE_ASSET__CTNJGPTv__"